import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewRole, updateRole } from '../../../../slices/auth/roles/thunk';
import { setRequireCloseModal } from '../../../../slices/auth/roles/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { PermissionsForm } from './PermissionsForm';

const RoleForm = ({
	dataRole,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [selectedVisibility, setselectedVisibility] = useState(null);

	function handleSelectVisibility(selectedVisibility) {
		setselectedVisibility(selectedVisibility);
	}

	const selectorRole = createSelector(
		state => state.Roles,
		user => ({
			isAdding: user.isAdding,
			isAdded: user.isAdded,
			isUpdating: user.isUpdating,
			isUpdated: user.isUpdated,
			isLoadingList: user.isLoadingList,
			requireCloseModal: user.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorRole);

	// validation
	const validation = useFormik({
		initialValues: {
			name: (dataRole && dataRole.name) || '',
			description: (dataRole && dataRole.description) || '',
			scopes: (dataRole && dataRole.scopes) || [],
			code: (dataRole && dataRole.code) || '',
			is_admin: (dataRole && dataRole.is_admin) || false,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			description: Yup.string().required('Campo requerido'),
			scopes: Yup.array().required('Campo requerido'),
			code: Yup.string().required('Campo requerido'),
			is_admin: Yup.boolean(),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedRole = {
					name: values.name,
					description: values.description,
					scopes: values.scopes,
					code: values.code,
					is_admin: values.is_admin,
				};
				dispatch(updateRole({ id: dataRole._id, role: updatedRole }));
			} else {
				const newRole = {
					name: values.name,
					description: values.description,
					scopes: values.scopes,
					code: values.code,
					is_admin: values.is_admin,
				};
				dispatch(addNewRole(newRole));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<Label for='name-field' className='form-label'>
									Nombre
								</Label>
								<Input
									name='name'
									id='name-field'
									className='form-control'
									placeholder='Ingrese el Nombre del Role'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name || ''}
									invalid={
										validation.touched.name && validation.errors.name
											? true
											: false
									}
								/>
								{validation.touched.name && validation.errors.name ? (
									<FormFeedback type='invalid'>
										{validation.errors.name}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={3}>
								<Label for='code-field' className='form-label'>
									Código
								</Label>
								<Input
									name='code'
									id='code-field'
									className='form-control'
									placeholder='Ingrese el Código del Role'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.code || ''}
									invalid={
										validation.touched.code && validation.errors.code
											? true
											: false
									}
								/>
								{validation.touched.code && validation.errors.code ? (
									<FormFeedback type='invalid'>
										{validation.errors.code}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={3}>
								<Label for='description-field' className='form-label'>
									Descripción
								</Label>
								<Input
									name='description'
									id='description-field'
									className='form-control'
									placeholder='Ingrese la descripción del Role'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.description || ''}
									invalid={
										validation.touched.description &&
										validation.errors.description
											? true
											: false
									}
								/>
								{validation.touched.description &&
								validation.errors.description ? (
									<FormFeedback type='invalid'>
										{validation.errors.description}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={2}>
								<div
									className='form-check'
									style={{
										marginTop: '2rem',
									}}
								>
									<Label
										className='form-check-label text-muted'
										for='isAdmin'
									>
										Es Administrador
									</Label>
									<input
										type='checkbox'
										className='form-check-input'
										id='isAdmin'
										checked={validation.values.is_admin}
										onChange={e => {
											validation.setFieldValue(
												'is_admin',
												e.target.checked
											);
										}}
									/>
								</div>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<PermissionsForm
							form={validation}
							isEdit={isEdit}
							dataRole={dataRole}
						/>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Actualizar Perfil' : 'Agregar Perfil'}
					</button>
				</div>
			</div>
		</Form>
	);
};

export default RoleForm;
